import React from 'react'
import MonitoringHero from './monitoringHero/MonitoringHero'
import MonitoringCounter from './monitoringCounter/MonitoringCounter'
import MonitoringApproach from './monitoringApproach/MonitoringApproach'
import MonitoringChoose from './monitoringChoose/MonitoringChoose'
import MonitoringService from './monitoringService/MonitoringService'
import MonitoringTestimonial from './monitoringTestimonial/MonitoringTestimonial'
import MonitoringVisibility from './monitoringVisibility/MonitoringVisibility'
import MonitoringBenefit from './monitoringBenefit/MonitoringBenefit'
import MonitoringWhat from './monitoringWhat/MonitoringWhat'
import MonitorCapability from './monitorCapability/MonitorCapability'

export default function Monitoring() {
  return (
    <div>
        <MonitoringHero/>
        <MonitoringCounter/>
        <MonitoringWhat/>
        <MonitorCapability/>
        <MonitoringApproach/>
        <MonitoringBenefit/>
        <MonitoringChoose/>
        <MonitoringVisibility/>
         <MonitoringTestimonial/>
        <MonitoringService/>
    </div>
  )
}
